module.exports = __webpack_public_path__ + "media/fonts/RecklessNeue-Heavy-df1124ebcb80782c373567c14db25e66.ttf";